<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('close')">
                <div class="modal-container-add-groupe" @click.stop>
                    <div class="modal-header-add-groupe">
                        {{ $t('_add_groupe_') }}
                        <slot name="cross">
                            <v-icon style="float: right; top: 0.3vh;" @click="$emit('close')">mdi-close</v-icon>
                        </slot>
                    </div>

                    <div class="modal-body-add-groupe">
                        <v-label style="color: black; font-weight: bold;"> {{ $t('_nom_') }}</v-label>
                        <v-text-field outlined class="inputField" v-model="nom">

                        </v-text-field>
                    </div>

                    <div class="modal-footer-add-groupe">
                        <v-btn style="float: right; background-color: #F49301; padding: 1vh; font-size: 1rem"
                            @click="valider">
                            {{ $t('_valider_') }}
                        </v-btn>
                                              
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>


export default {
    

    data() {
        return {
           nom:""
        }
    },

    methods: {
        valider() {
            if (!this.nom.trim()) return;
            this.$emit('save', this.nom);
            this.$emit('close');
            this.nom = "";
        }
    },
}
</script>

<style scoped>

.modal-container-add-groupe  {
    width: 40vw;
    height: 25vh;
    /* max-height: 80vh;
    min-height: 30vh; */
    margin: 0px auto;
    padding: 2vh;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    border-radius: 0.25rem;
    position: relative;
    flex-direction: column;
}

.modal-header-add-groupe {
    font-weight: bold;
    font-size: 1.5rem;
    color: #212121;
    height: fit-content;
}

.modal-body-add-groupe  {
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 1vh;
    padding-bottom: 1rem;
    width: 70%;
    margin-bottom: 15px;
}

.modal-footer-add-groupe  {
    padding: 16px 16px;
    background-color: white;
    color: white;
    position: absolute;
    width: 100%;
    bottom: 0;
    right: 0;
}


</style>